import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import WidthContainer from '../../../components/WidthContainer'
import {buttonType} from '../../../utils/commonPropTypes'
import {QueryedButton} from '../../../components/Button'
import Blob from '../../../components/Blob'

import personImage from '../images/person.svg'
import NewsletterForm from '../../../components/NewsletterForm'

const phoneBreakpoint = '@media only screen and (max-width: 1000px)'

const RootContainer = styled(WidthContainer)`
	display: flex;
	padding-top: 9.375rem; 
	margin-top: -6rem; 
	margin-bottom: -6rem; 
	justify-content: space-between;
	padding-bottom: 6rem;
	
	${phoneBreakpoint} {
		padding-bottom: 0rem;
		flex-direction: column-reverse;
		align-items: center;
		margin-bottom: 3rem;
		
		margin-top: -11rem;
	}
`

const CoursesBlob = styled(Blob)`
	position: relative;
`
CoursesBlob.defaultProps = {
	blobType: 4,
	minimalWidth: true,
}
const PersonImage = styled.img`
	position: absolute;
	top: -7rem;
	right: -4rem;
`


PersonImage.defaultProps = {
	src: personImage,
	alt: '',
}

const Column = styled.div`
	flex: 1;
	max-width: 26.8rem;
	margin: 6rem 0;
`

const Title = styled.h1`
	font-size: ${props => props.theme.fontSizes.big30};
	margin-bottom: 1.875rem;
`

const Text = styled.div`
	margin-bottom: 1.875rem;
	font-weight: ${props => props.theme.fontWeights.regular};
`


function CoursesNewsletterSection({className, data}) {
	return <RootContainer className={className}>
		<Column>
			<CoursesBlob>
				<PersonImage/>
				<Title>{data.courses.title}</Title>
				<Text>{data.courses.text}</Text>
				<QueryedButton data={data.courses.button}/>
			</CoursesBlob>
		</Column>
		<Column>
			<NewsletterForm/>
		</Column>
	</RootContainer>
}

CoursesNewsletterSection.propTypes = {
	className: PropTypes.string,
	data: PropTypes.shape({
		courses: PropTypes.shape({
			title: PropTypes.string.isRequired,
			text: PropTypes.string.isRequired,
			button: buttonType.isRequired,
		}).isRequired,
	}).isRequired,
}

CoursesNewsletterSection.defaultProps = {
	className: '',
}

export default CoursesNewsletterSection
